export const SHOW_CLASS_START_POP_UP = 'SHOW_CLASS_START_POP_UP';
export const SET_CURRENT_CHAPER_DETAILS = 'SET_CURRENT_CHAPER_DETAILS';
export const SET_SELECTED_CHAPTER_PILL_INFO = 'SET_SELECTED_CHAPTER_PILL_INFO';
export const SET_GETTING_SESSION_LIST = 'SET_GETTING_SESSION_LIST';
export const SET_SESSION_LIST = 'SET_SESSION_LIST';
export const GET_TEACHER_DETAILS = 'GET_TEACHER_DETAILS';
export const GETTING_TEACHER_DETAILS = 'GETTING_TEACHER_DETAILS';
export const ACTIVE_DEMO_CLASS_SESSION_ID = 'ACTIVE_DEMO_CLASS_SESSION_ID';
